import { axiosBaseQuery } from '@client';
import { createApi } from '@reduxjs/toolkit/dist/query/react';

export const evaluationApi = createApi({
  baseQuery: axiosBaseQuery({ baseUrl: 'secured/evaluation' }),
  tagTypes: ['EVALUATION', 'BudgetStatus', 'BudgetCommit'],
  reducerPath: 'evaluation-api',
  endpoints: () => ({})
});

export type StateWithEvaluationApi = {
  [evaluationApi.reducerPath]: ReturnType<typeof evaluationApi.reducer>;
};
